<template>
    <div v-if="row.length != 0" class="goodsorderlist">
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: "goodsorderlist",
    props: {
      row: [Object, Array],
      gotoWorkOrder: {
        type: Function,
        default: null
      }
    },
    computed:{
      keyword(){
        return this.$store.state.shopkey
      }
    },
    mounted() {
      
    },
  
    methods: {
      gotoWorkOrderFather() {
        this.gotoWorkOrder();
      }
    },
    
    watch:{
      
    }
  };
  </script>
  